import React, { PropsWithChildren } from 'react';

import { ButtonComponentProps, getButtonProps } from '../util/buttonProps';

import './PrimaryButton.css';

function PrimaryButton(props: PropsWithChildren<ButtonComponentProps>) {
  const { label, href, type, disabled, onClick } = props;
  const baseProps = getButtonProps(props, 'Primary');

  return href && !disabled ? (
    <a {...baseProps} href={href}>
      {props.children || label}
    </a>
  ) : (
    <button
      {...baseProps}
      type={type}
      onClick={onClick}
      onKeyDown={onClick}
      disabled={disabled}
    >
      {props.children || label}
    </button>
  );
}

PrimaryButton.defaultProps = {
  id: '',
  className: '',
  label: '',
  href: '',
  type: 'button',
  disabled: false,
};

export default PrimaryButton;
